import { useState } from 'react';

import { useToast } from '@/components/ui';
import { emailService } from '@/services/email.service';

export type LeadPdfKind = 'quotation' | 'client';

// Shared "download a server-rendered lead PDF" behaviour for the wizard steps
// (Fix 1). `downloading` is the kind currently in flight (or null), so a caller
// can show a spinner on the exact button that was clicked and disable both.
export const useLeadPdfDownload = (
  leadId: number,
): {
  download: (kind: LeadPdfKind) => Promise<void>;
  downloading: LeadPdfKind | null;
} => {
  const { toast } = useToast();
  const [downloading, setDownloading] = useState<LeadPdfKind | null>(null);

  const download = async (kind: LeadPdfKind): Promise<void> => {
    setDownloading(kind);
    try {
      await (kind === 'quotation'
        ? emailService.downloadQuotationPdf(leadId)
        : emailService.downloadClientInfoPdf(leadId));
    } catch {
      toast.error('Could not generate the PDF');
    } finally {
      setDownloading(null);
    }
  };

  return { download, downloading };
};
